export const integrationIds: Record<
  | "accountingFileUpload"
  | "bankingFileUpload"
  | "businessDocumentsFileUpload"
  | "nCino",
  string
> = {
  accountingFileUpload: "562e05d8-5438-4dc5-ad1e-e736a9b1ea05",
  bankingFileUpload: "70b57701-948b-4efc-b79d-07f10a379f58",
  businessDocumentsFileUpload: "fb1aefa8-c954-4c2f-be97-8b96a8daf004",
  nCino: "df59e3ff-adb1-4bfb-9c55-fc8df85a503a",
};

export const fileUploadIntegrationIds = [
  integrationIds["accountingFileUpload"],
  integrationIds["bankingFileUpload"],
  integrationIds["businessDocumentsFileUpload"],
];

export const clientRuleTypes: string[] = [
  "Rate Limit Reached",
  "Rate Limit Reset",
];
